(() => {
  angular
    .module('gm.common.directives')
    .directive('gmLoadArticle', gmLoadArticleDirective);

  /**
   * Display specified by slug article
   *
   * @param {Object} $log
   * @param {Object} $rootScope
   * @param {Object} GmyWordpressApi
   */
  function gmLoadArticleDirective(
    $log,
    $rootScope,
    GmyWordpressApi
  ) {
    'ngInject';

    /**
     * Defines parsers rules
     */
    const contentParserMap = {
      'privacy-security': {
        pattern: '(\\<code\\>(.*?)\\<\\/code\\>)',
        replacement(label) {
          return `<span class="section-number">${label}</span>`;
        }
      }
    };

    return {
      restrict: 'E',
      scope: {
        cache: '=?',
        slug: '@'
      },
      templateUrl: 'modules/common/directives/load-article/load-article.html',

      link(scope) {
        scope.cache = scope.cache || false;

        GmyWordpressApi
          .getPostBySlug(scope.slug, 'page', scope.cache)
          .then((data) => {
            $rootScope.$broadcast('gm:loaded:article', {
              date: data.data[0].date_gmt,
              title: data.data[0].title.rendered
            });

            updateContent(scope, data.data[0].content.rendered, scope.slug);
          })
          .catch((error) => {
            $rootScope.$broadcast('remove.queue-section', `load-${scope.slug}`);
            $log.debug(error);
          });
      },
    };

    /**
     * Convert content text
     *
     * @param  {String} content
     * @param  {Object} config
     * @return {String}
     */
    function convertContent(content, config) {
      const regexNumber = new RegExp(config.pattern, 'g');

      return content.replace(regexNumber, (_match, _p1, p2) => config.replacement(p2));
    }

    /**
     * Remove BR tags from content
     *
     * @param  {String} content
     * @return {String}
     */
    function removeBr(content) {
      const regexBr = new RegExp('(\\<br[\\s,\\/]{0,}\\>)', 'g');

      return content.replace(regexBr, '');
    }

    /**
     * Load content on the page
     *
     * @param {Object} scope
     * @param {String} content of the article
     * @param {String} slug
     */
    function updateContent(scope, origContent, slug) {
      // remove any <br> tag
      const content = removeBr(origContent);

      // apply specific to the page content parser
      if (contentParserMap[slug]) {
        scope.article = convertContent(content, contentParserMap[slug]);
      } else {
        scope.article = content;
      }

      $rootScope.$broadcast('add.queue-section', `load-${scope.slug}`);
    }
  }
})();
